module.exports = __webpack_public_path__ + "static/images/components/Nation/images/flag-cn-usa.1450446d.png";


//////////////////
// WEBPACK FOOTER
// ./components/Nation/images/flag-cn-usa.png
// module id = 2633
// module chunks = 11